// src/store/slices/gallerySlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axiosConfig';

// Thunk para obtener imágenes filtradas (event|venue)
export const fetchGalleryImages = createAsyncThunk(
  'gallery/fetchGalleryImages',
  async ({ slug, category = 'event' }, { rejectWithValue }) => {
    try {
      const res = await axios.get(`/${slug}/api/images`, { params: { category } });
      return res.data.images || [];
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const gallerySlice = createSlice({
  name: 'gallery',
  initialState: { images: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGalleryImages.pending, (state) => {
        state.loading = true; state.error = null;
      })
      .addCase(fetchGalleryImages.fulfilled, (state, action) => {
        state.loading = false; state.images = action.payload;
      })
      .addCase(fetchGalleryImages.rejected, (state, action) => {
        state.loading = false; state.error = action.payload;
      });
  },
});

export default gallerySlice.reducer;


// // src/store/slices/gallerySlice.js
// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axios from '../../utils/axiosConfig';

// // Thunk para obtener imágenes de la galería
// export const fetchGalleryImages = createAsyncThunk(
//   'gallery/fetchGalleryImages',
//   async (slug, { rejectWithValue }) => {
//     try {
//       const res = await axios.get(`/${slug}/api/images`);
//        return res.data.images; // ✅ Devuelve solo el array
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// const gallerySlice = createSlice({
//   name: 'gallery',
//   initialState: {
//     images: [],
//     loading: false,
//     error: null,
//   },
//   reducers: {},
//   extraReducers: builder => {
//     builder
//       .addCase(fetchGalleryImages.pending, state => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchGalleryImages.fulfilled, (state, action) => {
//         state.images = action.payload;
//         state.loading = false;
//       })
//       .addCase(fetchGalleryImages.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export default gallerySlice.reducer;
